import React from 'react';
import { Box, Skeleton } from '@mui/material';

import { LastSessionSection, PatientOverviewSection } from '../../AppointmentCard.styles';

/**
 * Loading skeleton for patient clinical details
 * Matches the layout of PatientOverview and LastSessionSummary components
 */
export const ClinicalDetailsSkeleton: React.FC = () => {
  return (
    <>
      {/* Patient Overview Skeleton */}
      <PatientOverviewSection>
        {/* Title */}
        <Skeleton variant="text" width={150} height={24} />

        {/* Pronouns */}
        <Skeleton variant="text" width="60%" height={20} />

        {/* Diagnosis */}
        <Skeleton variant="text" width="85%" height={20} />

        {/* Questionnaires */}
        <Skeleton variant="text" width="70%" height={20} />

        {/* Medications */}
        <Skeleton variant="text" width="75%" height={20} />
      </PatientOverviewSection>

      {/* Last Session Summary Skeleton */}
      <LastSessionSection>
        {/* Title with date */}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Skeleton variant="text" width={180} height={24} />
          <Skeleton variant="text" width={60} height={18} />
        </Box>

        {/* Summary text - multiple lines */}
        <Skeleton variant="text" width="100%" height={20} />
        <Skeleton variant="text" width="95%" height={20} />
        <Skeleton variant="text" width="80%" height={20} />
      </LastSessionSection>
    </>
  );
};
